import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

import "./Navbar.scss";
import logo from "./../../img/logos/mfly_white.png";

const links = [
  // { name: "Home", path: "/" },
  // { name: "About", path: "/about" },
  // { name: "Design", path: "/design" },
  { name: "Members", path: "/members" },
  { name: "Sponsors", path: "/sponsors" },
  { name: "Get Involved", path: "/get-involved" },
];

const aircraftLinks = [
  { name: "Hi-Lift", path: "/aircraft/hi-lift" },
  { name: "Advanced", path: "/aircraft/advanced" },
  { name: "Auton", path: "/aircraft/auton" },
  { name: "History", path: "/aircraft/history" },
];

const socials = [
  { icon: faFacebook, 
    url: "https://www.facebook.com/UmichMFLY/", 
    name: "Facebook" },
  { icon: faInstagram, 
    url: "https://www.instagram.com/mfly_umich/", 
    name: "Instagram" },
  { icon: faLinkedin,
    url: "https://www.linkedin.com/company/m-fly-aero-design/",
    name: "Linkedin"},
  { icon: faTwitter, 
    url: "https://twitter.com/UofM_MFly",
    name: "Twitter" },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [aircraftOpen, setAircraftOpen] = useState(false);

  const closeMenus = () => {
    setOpen(false);
    setAircraftOpen(false);
  };

  return (
    <div className={"mfly-navbar" + (open ? " responsive" : "")}>
      <Link to="/" className="logo" onClick={closeMenus}>
        <img src={logo} alt="M-Fly" />
      </Link>
      <div className="nav-links">
        <div className={"nav-item dropdown" + (aircraftOpen ? " open" : "")}
        >
          <button
            type="button"
            className={
              "dropdown-toggle" +
              (pathname.startsWith("/aircraft") ? " active" : "")
            }
            onClick={() => setAircraftOpen((prev) => !prev)}
            aria-haspopup="true"
            aria-expanded={aircraftOpen}
          >
            Aircraft
          </button>
          <div className="dropdown-menu" role="menu">
            {aircraftLinks.map(({ name, path }) => (
              <Link
                key={path}
                to={path}
                className={path === pathname ? "active" : ""}
                onClick={closeMenus}
              >
                {name}
              </Link>
            ))}
          </div>
        </div>
        {links.map(({ name, path }) => (
          <Link
            key={path}
            to={path}
            className={path === pathname ? "active" : ""}
            onClick={closeMenus}
          >
            {name}
          </Link>
        ))}
      </div>
      <div className="socials">
      {socials.map(({ url, icon, name }) => (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="social"
          aria-label={name}
          key={name}
        >
          <FontAwesomeIcon icon={icon} size="lg" />
        </a>
      ))}
      </div>
      <a
        href="#"
        className="icon"
        onClick={() => {
          setOpen((prev) => {
            if (prev) {
              setAircraftOpen(false);
            }
            return !prev;
          });
        }}
      >
        <FontAwesomeIcon icon={faBars} size="lg" color="white" />
      </a>
    </div>
  );
}
